declare var pglob : IPhotometerGlobalVar;

module product {
  'use strict';

  export class ProductArchiveCtrl {

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope', 
      '$http', 
      'pageMetaService',
    ];

    // dependencies are injected via AngularJS $injector
    constructor(
      private $scope: IProductArchiveScope,
      private $http: ng.IHttpService,
      private pageMetaService: navigation.IPageMetaService
      ) {
     
      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;
      this.load();
    } 


    load() {

      this.$http<search.Product[]>({
                  method: "GET"
                , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Product/Archived"
                , headers: { 'Content-Type': 'application/json' }
                , params: {}
        }).then(( response : {data : search.Product[]}) => {
          this.$scope.products = response.data;
        });

    };  

    
  }

}